import { scalePoint } from 'd3-scale';
export default function pointScale(_ref) {
  var range = _ref.range,
      rangeRound = _ref.rangeRound,
      domain = _ref.domain,
      padding = _ref.padding,
      align = _ref.align;
  var scale = scalePoint();
  if (range) scale.range(range);
  if (rangeRound) scale.rangeRound(rangeRound);
  if (domain) scale.domain(domain);
  if (padding) scale.padding(padding);
  if (align) scale.align(align); // @ts-ignore

  scale.type = 'point';
  return scale;
}